import {defineMessages, FormattedMessage} from 'react-intl';
import {Link, Icon, view} from '@sail/ui';
import {chevronDown, chevronUp} from '@sail/icons/react/Icon';

const messages = defineMessages({
  title: {
    id: 'conversations_ui.widget.requestACallTopBar.title',
    description: 'Title of the request a call top bar',
    defaultMessage: 'Have us call you',
  },
  showDetails: {
    id: 'conversations_ui.widget.requestACallTopBar.showDetails',
    description: 'Toggle button to show more details about call state',
    defaultMessage: 'Show details',
  },
  hideDetails: {
    id: 'conversations_ui.widget.requestACallTopBar.hideDetails',
    description: 'Toggle button to hide details about call state',
    defaultMessage: 'Hide details',
  },
});

export const Title = ({
  showDetails,
  onToggle,
}: {
  showDetails: boolean;
  onToggle: () => void;
}) => (
  <view.div
    css={{
      font: 'label.medium.emphasized',
      stack: 'x',
      distribute: 'space-between',
    }}
  >
    <FormattedMessage {...messages.title} />
    <Link
      onPress={onToggle}
      css={{
        font: 'label.small.emphasized',
      }}
    >
      <FormattedMessage
        {...(showDetails ? messages.hideDetails : messages.showDetails)}
      />
      <Icon
        icon={showDetails ? chevronUp : chevronDown}
        size="xxsmall"
        css={{marginLeft: 'xsmall'}}
      />
    </Link>
  </view.div>
);
